<div class="container-fluid p-0 m-0">
  <div class="card border-0 p-0 m-0">
    <div class="card-header">
      <span
        class="btn"
        (click)="dismiss()"
        style="float: right; color: #fff"
        class="material-symbols-outlined"
        >close</span
      >
      Rules
    </div>
    <div class="card-body p-1 pb-4">
      <div class="casino-vieo-rules show-rules show">
        <!-- aaa -->
        <div class="rules-body" *ngIf="gtype == 'aaa'">
          <div>
            <style type="text/css">
              .rules-section .row.row5 {
                margin-left: -5px;
                margin-right: -5px;
              }
              .rules-section .pl-2 {
                padding-left: 0.5rem !important;
              }
              .rules-section .pr-2 {
                padding-right: 0.5rem !important;
              }
              .rules-section .row.row5 > [class*="col-"],
              .rules-section .row.row5 > [class*="col"] {
                padding-left: 5px;
                padding-right: 5px;
              }
              .rules-section {
                text-align: left;
                margin-bottom: 10px;
              }
              .rules-section .table {
                color: #fff;
                border: 1px solid #444;
                background-color: #222;
                font-size: 12px;
              }
              .rules-section .table td,
              .rules-section .table th {
                border-bottom: 1px solid #444;
              }
              .rules-section ul li,
              .rules-section p {
                margin-bottom: 5px;
              }
              .rules-section::-webkit-scrollbar {
                width: 8px;
              }
              .rules-section::-webkit-scrollbar-track {
                background: #666666;
              }

              .rules-section::-webkit-scrollbar-thumb {
                background-color: #333333;
              }
              .rules-section .rules-highlight {
                color: #fdcf13;
                font-size: 16px;
              }
              .rules-section .rules-sub-highlight {
                color: #fdcf13;
                font-size: 14px;
              }
              .rules-section .list-style,
              .rules-section .list-style li {
                list-style: disc;
              }
              .rules-section .rule-card {
                height: 20px;
                margin-left: 5px;
              }
              .rules-section .card-character {
                font-family: Card Characters;
              }
              .rules-section .red-card {
                color: red;
              }
              .rules-section .black-card {
                color: black;
              }
              .rules-section .cards-box {
                background: #fff;
                padding: 6px;
                display: inline-block;
                color: #000;
                min-width: 150px;
              }
            </style>

            <div class="rules-section">
              <ul class="pl-4 pr-4 list-style">
                <li>If the card is ACE,2,3,4,5, or 6 Amar Wins.</li>
                <li>If the card is 7,8,9 or 10 Akbar wins.</li>
                <li>If the card is J,Q or K Anthony wins.</li>
              </ul>
            </div>
          </div>

          <div>
            <div class="rules-section">
              <p>
                <b class="rules-sub-highlight">EVEN</b>
                <span class="ml-2">(PAYOUT 2.12)</span>
              </p>
              <ul class="pl-4 pr-4 list-style">
                <li>If the card is 2 , 4 , 6 , 8 , 10 , Q</li>
              </ul>
              <p>
                <b class="rules-sub-highlight">ODD</b>
                <span class="ml-2">(PAYOUT 1.83)</span>
              </p>
              <ul class="pl-4 pr-4 list-style">
                <li>If the card is A , 3 , 5 , 7 , 9 , J , K</li>
              </ul>
              <p>
                <b class="rules-sub-highlight">RED</b>
                <span class="ml-2">(PAYOUT 1.97)</span>
              </p>
              <ul class="pl-4 pr-4 list-style">
                <li>If the card color is DIAMOND or HEART</li>
              </ul>
              <p>
                <b class="rules-sub-highlight">BLACK</b>
                <span class="ml-2">(PAYOUT 1.97)</span>
              </p>
              <ul class="pl-4 pr-4 list-style">
                <li>If the card color is CLUB or SPADE</li>
              </ul>
              <p>
                <b class="rules-sub-highlight">UNDER 7</b>
                <span class="ml-2">(PAYOUT 2.0)</span>
              </p>
              <ul class="pl-4 pr-4 list-style">
                <li>If the card is A , 2 , 3 , 4 , 5 , 6</li>
              </ul>
              <p>
                <b class="rules-sub-highlight">OVER 7</b>
                <span class="ml-2">(PAYOUT 2.0)</span>
              </p>
              <ul class="pl-4 pr-4 list-style">
                <li>If the card is 8 , 9 , 10 , J , Q , K</li>
              </ul>
              <p>
                <b>Note: </b>
                <span
                  >If the card is 7, Bets on under 7 and over 7 will lose 50% of
                  the bet amount.</span
                >
              </p>
              <p>
                <b class="rules-sub-highlight">CARDS</b>
                <span class="ml-2">(PAYOUT 12.0)</span>
              </p>
              <ul class="pl-4 pr-4 list-style">
                <li>A , 2 , 3 , 4 , 5 , 6 , 7 , 8 , 9 , 10 , J , Q , K</li>
              </ul>
            </div>
          </div>

          <!-- andarbahar2 -->
        </div>
        <!-- andarbahar2 -->
        <div class="rules-body" *ngIf="gtype == 'abj'">
          <div>
            <style type="text/css">
              .rules-section .row.row5 {
                margin-left: -5px;
                margin-right: -5px;
              }
              .rules-section .pl-2 {
                padding-left: 0.5rem !important;
              }
              .rules-section .pr-2 {
                padding-right: 0.5rem !important;
              }
              .rules-section .row.row5 > [class*="col-"],
              .rules-section .row.row5 > [class*="col"] {
                padding-left: 5px;
                padding-right: 5px;
              }
              .rules-section {
                text-align: left;
                margin-bottom: 10px;
              }
              .rules-section .table {
                color: #fff;
                border: 1px solid #444;
                background-color: #222;
                font-size: 12px;
              }
              .rules-section .table td,
              .rules-section .table th {
                border-bottom: 1px solid #444;
              }
              .rules-section ul li,
              .rules-section p {
                margin-bottom: 5px;
              }
              .rules-section::-webkit-scrollbar {
                width: 8px;
              }
              .rules-section::-webkit-scrollbar-track {
                background: #666666;
              }

              .rules-section::-webkit-scrollbar-thumb {
                background-color: #333333;
              }
              .rules-section .rules-highlight {
                color: #fdcf13;
                font-size: 16px;
              }
              .rules-section .rules-sub-highlight {
                color: #fdcf13;
                font-size: 14px;
              }
              .rules-section .list-style,
              .rules-section .list-style li {
                list-style: disc;
              }
              .rules-section .rule-card {
                height: 20px;
                margin-left: 5px;
              }
              .rules-section .card-character {
                font-family: Card Characters;
              }
              .rules-section .red-card {
                color: red;
              }
              .rules-section .black-card {
                color: black;
              }
              .rules-section .cards-box {
                background: #fff;
                padding: 6px;
                display: inline-block;
                color: #000;
                min-width: 150px;
              }
              .rules-section img {
                height: 30px;
                margin-right: 5px;
              }
              .rules-section .casino-tabs {
                background-color: #222 !important;
                border-radius: 0;
              }
              .rules-section .casino-tabs .nav-tabs .nav-link {
                color: #fff !important;
              }
              .rules-section .casino-tabs .nav-tabs .nav-link.active {
                color: #fdcf13 !important;
                border-bottom: 3px solid #fdcf13 !important;
              }
            </style>

            <div class="rules-section">
              <h6 class="rules-highlight">Rules</h6>
              <ul class="pl-4 pr-4 list-style">
                <li>
                  Andar Bahar is a very simple game that involves the use of a
                  single pack of cards.Game is played between the House and the
                  Player. The dealer deals a single card face up on the Joker
                  place and then proceeds to deal cards face up on A (ANDAR) and
                  B (BAHAR) spots. When a card appears that matches the value of
                  the Joker card then the game ends. Before the start of the
                  game, players bet on which side they think the game will end.
                </li>
                <li>
                  Before dealer starts dealing/opening cards from the deck,
                  he/she also offers a side bet to the players who have
                  estimated time to bet if the card/joker will be dealt as the
                  1st card.
                </li>
                <li>
                  If the 1st placed card doesn't match the value of the Joker's
                  card, the game continues and the dealer then offers the option
                  to players to put their 2nd bet on the same joker card to be
                  dealt either on ANDAR or on BAHAR. The players again have
                  estimated time to decide if they want to place a 2nd bet.
                  Dealer deals the cards one at a time alternating between two
                  spots.
                </li>
                <li>
                  If the 1st dealt card in 1st bet matches the joker’s card,
                  Bahar side wins with payout 1:0,5
                </li>
                <li>
                  If the 1st dealt card in 1st bet matches the joker’s card,
                  Andar side wins with payout 1:0,5
                </li>
                <li>
                  If the 2nd dealt card in 1st bet matches the joker’s card,
                  Bahar side wins with payout 1:0,5
                </li>
                <li>
                  If the 2nd dealt card in 1st bet matches the joker’s card,
                  Andar side wins with payou 1:0,5
                </li>
              </ul>
            </div>
          </div>
          <div>
            <style type="text/css">
              .rules-section .row.row5 {
                margin-left: -5px;
                margin-right: -5px;
              }
              .rules-section .pl-2 {
                padding-left: 0.5rem !important;
              }
              .rules-section .pr-2 {
                padding-right: 0.5rem !important;
              }
              .rules-section .row.row5 > [class*="col-"],
              .rules-section .row.row5 > [class*="col"] {
                padding-left: 5px;
                padding-right: 5px;
              }
              .rules-section {
                text-align: left;
                margin-bottom: 10px;
              }
              .rules-section .table {
                color: #fff;
                border: 1px solid #444;
                background-color: #222;
                font-size: 12px;
              }
              .rules-section .table td,
              .rules-section .table th {
                border-bottom: 1px solid #444;
              }
              .rules-section ul li,
              .rules-section p {
                margin-bottom: 5px;
              }
              .rules-section::-webkit-scrollbar {
                width: 8px;
              }
              .rules-section::-webkit-scrollbar-track {
                background: #666666;
              }

              .rules-section::-webkit-scrollbar-thumb {
                background-color: #333333;
              }
              .rules-section .rules-highlight {
                color: #fdcf13;
                font-size: 16px;
              }
              .rules-section .rules-sub-highlight {
                color: #fdcf13;
                font-size: 14px;
              }
              .rules-section .list-style,
              .rules-section .list-style li {
                list-style: disc;
              }
              .rules-section .rule-card {
                height: 20px;
                margin-left: 5px;
              }
              .rules-section .card-character {
                font-family: Card Characters;
              }
              .rules-section .red-card {
                color: red;
              }
              .rules-section .black-card {
                color: black;
              }
              .rules-section .cards-box {
                background: #fff;
                padding: 6px;
                display: inline-block;
                color: #000;
                min-width: 150px;
              }
              .rules-section img {
                height: 30px;
                margin-right: 5px;
              }
              .rules-section .casino-tabs {
                background-color: #222 !important;
                border-radius: 0;
              }
              .rules-section .casino-tabs .nav-tabs .nav-link {
                color: #fff !important;
              }
              .rules-section .casino-tabs .nav-tabs .nav-link.active {
                color: #fdcf13 !important;
                border-bottom: 3px solid #fdcf13 !important;
              }
            </style>

            <div class="rules-section">
              <h6 class="rules-highlight">Payout</h6>
              <div class="table-responsive">
                <table class="table">
                  <thead>
                    <tr>
                      <th>Bet</th>
                      <th>Description</th>
                      <th>Payout</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>1st Bet Bahar</td>
                      <td>Payout if Bahar Wins on the 1st bet</td>
                      <td>1 to 1</td>
                    </tr>
                    <tr>
                      <td>1st Bet Andar</td>
                      <td>Payout if Andar wins on the 1st bet</td>
                      <td>1 to 1</td>
                    </tr>
                    <tr>
                      <td>2nd Bet Bahar</td>
                      <td>Payout if Bahar wins on the 2nd bet</td>
                      <td>1 to 1</td>
                    </tr>
                    <tr>
                      <td>2nd Bet Andar</td>
                      <td>Payout if Andar wins on the 1st bet</td>
                      <td>1 to 1</td>
                    </tr>
                    <tr>
                      <td>Side Bets Bahar</td>
                      <td>Payout for winning side bet.</td>
                      <td>1 to 14</td>
                    </tr>
                    <tr>
                      <td>Side Bets Andar</td>
                      <td>Payout for winning side bet.</td>
                      <td>1 to 14</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <!-- baccarat1 -->
        <div class="rules-body" *ngIf="gtype == 'baccarat1'">
          <div>
            <style type="text/css">
              .rules-section .row.row5 {
                margin-left: -5px;
                margin-right: -5px;
              }
              .rules-section .pl-2 {
                padding-left: 0.5rem !important;
              }
              .rules-section .pr-2 {
                padding-right: 0.5rem !important;
              }
              .rules-section .row.row5 > [class*="col-"],
              .rules-section .row.row5 > [class*="col"] {
                padding-left: 5px;
                padding-right: 5px;
              }
              .rules-section {
                text-align: left;
                margin-bottom: 10px;
              }
              .rules-section .table {
                color: #fff;
                border: 1px solid #444;
                background-color: #222;
                font-size: 12px;
              }
              .rules-section .table td,
              .rules-section .table th {
                border-bottom: 1px solid #444;
                border-right: 1px solid #444;
                vertical-align: middle;
                text-align: center;
              }
              .rules-section ul li,
              .rules-section p {
                margin-bottom: 5px;
              }
              .rules-section::-webkit-scrollbar {
                width: 8px;
              }
              .rules-section::-webkit-scrollbar-track {
                background: #666666;
              }

              .rules-section::-webkit-scrollbar-thumb {
                background-color: #333333;
              }
              .rules-section .rules-highlight {
                color: #fdcf13;
                font-size: 16px;
              }
              .rules-section .rules-sub-highlight {
                color: #fdcf13;
                font-size: 14px;
              }
              .rules-section .list-style,
              .rules-section .list-style li {
                list-style: disc;
              }
              .rules-section .rule-card {
                height: 20px;
                margin-left: 5px;
              }
              .rules-section .card-character {
                font-family: Card Characters;
              }
              .rules-section .red-card {
                color: red;
              }
              .rules-section .black-card {
                color: black;
              }
              .rules-section .cards-box {
                background: #fff;
                padding: 6px;
                display: inline-block;
                color: #000;
                min-width: 150px;
              }
              .rules-section img {
                height: 30px;
                margin-right: 5px;
              }
              .rules-section .casino-tabs {
                background-color: #222 !important;
                border-radius: 0;
              }
              .rules-section .casino-tabs .nav-tabs .nav-link {
                color: #fff !important;
              }
              .rules-section .casino-tabs .nav-tabs .nav-link.active {
                color: #fdcf13 !important;
                border-bottom: 3px solid #fdcf13 !important;
              }
            </style>

            <div class="rules-section">
              <ul class="pl-2 pr-2 list-style">
                <li>
                  In the Baccarat game two hands are dealt; once for the banker
                  and another for the player. The player best which will win or
                  if they will tie. The winning hand has the closest value to
                  nine. In case of Banker winning, if banker's point sum is
                  equals to 6, then payout will be 50%.
                </li>
              </ul>
            </div>
          </div>
          <div>
            <div class="rules-section">
              <h6 class="rules-highlight">Rules for Players:</h6>
              <div class="table-responsive">
                <table class="table">
                  <tbody>
                    <tr>
                      <td rowspan="3">When Player’s first two cards total:</td>
                      <td>0-1-2-3-4-5</td>
                      <td>Draw a card</td>
                    </tr>
                    <tr>
                      <td>6-7</td>
                      <td>Stands</td>
                    </tr>
                    <tr>
                      <td>8-9</td>
                      <td>Natural-Neither hand draws</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div>
            <div class="rules-section">
              <h6 class="rules-highlight">Rules for Banker:</h6>
              <ul class="pl-2 pr-2 list-style">
                <li>
                  When the PLAYER stands on 6 or 7, the BANKER will always draw
                  on totals of 0-1-2-3-4 and 5, and stands on 6-7-8 and 9.When
                  the PLAYER does not have a natural, the BANKER shall draw on
                  the totals of 0-1 or 2, and then observe the following rules:
                </li>
              </ul>
              <div class="table-responsive">
                <table class="table">
                  <tbody>
                    <tr>
                      <td>When Banker’s first two cards total:</td>
                      <td>Draws when Player’s third card is:</td>
                      <td>Does not draw when Player’s third card is:</td>
                    </tr>
                    <tr>
                      <td>3</td>
                      <td>1-2-3-4-5-6-7-9-0</td>
                      <td>8</td>
                    </tr>
                    <tr>
                      <td>4</td>
                      <td>2-3-4-5-6-7</td>
                      <td>1-8-9-0</td>
                    </tr>
                    <tr>
                      <td>5</td>
                      <td>4-5-6-7</td>
                      <td>1-2-3-8-9-0</td>
                    </tr>
                    <tr>
                      <td>6</td>
                      <td>6-7</td>
                      <td>1-2-3-4-5-8-9-0</td>
                    </tr>
                    <tr>
                      <td>7</td>
                      <td colspan="2">STANDS</td>
                    </tr>
                    <tr>
                      <td>8-9</td>
                      <td colspan="2">NATURAL-NEITHER HAND DRAWS</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <ul class="pl-2 pr-2 list-style">
                <li>
                  If the PLAYER takes no third card BANKER stands on 6. The hand
                  closest to 9 wins.All Winning bets are paid even money.TIE
                  bets pay 8 for 1
                </li>
              </ul>
            </div>
          </div>
          <div>
            <div class="rules-section">
              <h6 class="rules-highlight">Side Bets:</h6>
              <ul class="pl-2 pr-2 list-style">
                <li>
                  <b>Player Pair</b> - Bet on the chance that the first two
                  cards dealt to the player, are a pair.
                </li>
                <li>
                  <b>Banker Pair</b> - Bet on the chance that the first two
                  cards dealt to the banker, are a pair.
                </li>
                <li>
                  <b>Big</b> - Bet on the chance that the total number of cards
                  dealt between Player and Banker is 5 or 6.
                </li>
                <li>
                  <b>Small</b> - Bet on the chance that the total number of
                  cards dealt between Player and Banker is 4.
                </li>
                <li>
                  <b>Perfect Pair</b> - Bet on the chance that the first two
                  Player or Banker cards form a pair of the same suit.
                </li>
                <li>
                  <b>Either Pair</b> - Bet on the chance that either the first
                  two cards of the Banker hand or the first two cards of the
                  Player hand (or both) form a pair.
                </li>
              </ul>
            </div>
          </div>
        </div>
        <!-- baccarat2 -->
        <div class="rules-body" *ngIf="gtype == 'baccarat2'">
          <div>
            <style type="text/css">
              .rules-section .row.row5 {
                margin-left: -5px;
                margin-right: -5px;
              }
              .rules-section .pl-2 {
                padding-left: 0.5rem !important;
              }
              .rules-section .pr-2 {
                padding-right: 0.5rem !important;
              }
              .rules-section .row.row5 > [class*="col-"],
              .rules-section .row.row5 > [class*="col"] {
                padding-left: 5px;
                padding-right: 5px;
              }
              .rules-section {
                text-align: left;
                margin-bottom: 10px;
              }
              .rules-section .table {
                color: #fff;
                border: 1px solid #444;
                background-color: #222;
                font-size: 12px;
              }
              .rules-section .table td,
              .rules-section .table th {
                border-bottom: 1px solid #444;
                border-right: 1px solid #444;
                vertical-align: middle;
                text-align: center;
              }
              .rules-section ul li,
              .rules-section p {
                margin-bottom: 5px;
              }
              .rules-section::-webkit-scrollbar {
                width: 8px;
              }
              .rules-section::-webkit-scrollbar-track {
                background: #666666;
              }

              .rules-section::-webkit-scrollbar-thumb {
                background-color: #333333;
              }
              .rules-section .rules-highlight {
                color: #fdcf13;
                font-size: 16px;
              }
              .rules-section .rules-sub-highlight {
                color: #fdcf13;
                font-size: 14px;
              }
              .rules-section .list-style,
              .rules-section .list-style li {
                list-style: disc;
              }
              .rules-section .rule-card {
                height: 20px;
                margin-left: 5px;
              }
              .rules-section .card-character {
                font-family: Card Characters;
              }
              .rules-section .red-card {
                color: red;
              }
              .rules-section .black-card {
                color: black;
              }
              .rules-section .cards-box {
                background: #fff;
                padding: 6px;
                display: inline-block;
                color: #000;
                min-width: 150px;
              }
              .rules-section img {
                height: 30px;
                margin-right: 5px;
              }
              .rules-section .casino-tabs {
                background-color: #222 !important;
                border-radius: 0;
              }
              .rules-section .casino-tabs .nav-tabs .nav-link {
                color: #fff !important;
              }
              .rules-section .casino-tabs .nav-tabs .nav-link.active {
                color: #fdcf13 !important;
                border-bottom: 3px solid #fdcf13 !important;
              }
            </style>

            <div class="rules-section">
              <ul class="pl-2 pr-2 list-style">
                <li>
                  In the Baccarat game two hands are dealt; once for the banker
                  and another for the player. The player best which will win or
                  if they will tie. The winning hand has the closest value to
                  nine. In case of Banker winning, if banker's point sum is
                  equals to 6, then payout will be 50%.
                </li>
              </ul>
            </div>
          </div>
          <div>
            <div class="rules-section">
              <h6 class="rules-highlight">Rules for Players:</h6>
              <div class="table-responsive">
                <table class="table">
                  <tbody>
                    <tr>
                      <td rowspan="3">When Player’s first two cards total:</td>
                      <td>0-1-2-3-4-5</td>
                      <td>Draw a card</td>
                    </tr>
                    <tr>
                      <td>6-7</td>
                      <td>Stands</td>
                    </tr>
                    <tr>
                      <td>8-9</td>
                      <td>Natural-Neither hand draws</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div>
            <div class="rules-section">
              <h6 class="rules-highlight">Rules for Banker:</h6>
              <ul class="pl-2 pr-2 list-style">
                <li>
                  When the PLAYER stands on 6 or 7, the BANKER will always draw
                  on totals of 0-1-2-3-4 and 5, and stands on 6-7-8 and 9.When
                  the PLAYER does not have a natural, the BANKER shall draw on
                  the totals of 0-1 or 2, and then observe the following rules:
                </li>
              </ul>
              <div class="table-responsive">
                <table class="table">
                  <tbody>
                    <tr>
                      <td>When Banker’s first two cards total:</td>
                      <td>Draws when Player’s third card is:</td>
                      <td>Does not draw when Player’s third card is:</td>
                    </tr>
                    <tr>
                      <td>3</td>
                      <td>1-2-3-4-5-6-7-9-0</td>
                      <td>8</td>
                    </tr>
                    <tr>
                      <td>4</td>
                      <td>2-3-4-5-6-7</td>
                      <td>1-8-9-0</td>
                    </tr>
                    <tr>
                      <td>5</td>
                      <td>4-5-6-7</td>
                      <td>1-2-3-8-9-0</td>
                    </tr>
                    <tr>
                      <td>6</td>
                      <td>6-7</td>
                      <td>1-2-3-4-5-8-9-0</td>
                    </tr>
                    <tr>
                      <td>7</td>
                      <td colspan="2">STANDS</td>
                    </tr>
                    <tr>
                      <td>8-9</td>
                      <td colspan="2">NATURAL-NEITHER HAND DRAWS</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <ul class="pl-2 pr-2 list-style">
                <li>
                  If the PLAYER takes no third card BANKER stands on 6. The hand
                  closest to 9 wins.All Winning bets are paid even money.TIE
                  bets pay 8 for 1
                </li>
              </ul>
            </div>
          </div>
          <div>
            <div class="rules-section">
              <h6 class="rules-highlight">Side Bets:</h6>
              <ul class="pl-2 pr-2 list-style">
                <li>
                  <b>Player Pair</b> - Bet on the chance that the first two
                  cards dealt to the player, are a pair.
                </li>
                <li>
                  <b>Banker Pair</b> - Bet on the chance that the first two
                  cards dealt to the banker, are a pair.
                </li>
                <li>
                  Select the Player/Banker winning score and get paid according
                  to the payout shown. in the event of tie, bets on “Winning
                  Total” are lost
                </li>
              </ul>
              <div class="table-responsive">
                <table class="table">
                  <tbody>
                    <tr>
                      <td>1-4(7:5:1)</td>
                      <td>5-6(4:1)</td>
                      <td>7(4:5:1)</td>
                      <td>8(3:1)</td>
                      <td>9(2:5:1)</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <ul class="pl-2 pr-2 list-style">
                <li>
                  For example, if you believe the Player/Banker winning score
                  will be '5-6'(meaning 5 or 6) then if this side bet wins you
                  can win 4 times your side bet amount
                </li>
              </ul>
            </div>
          </div>
        </div>
        <!-- card32A -->
        <div class="rules-body" *ngIf="gtype == 'card32a'">
          <div>
            <style type="text/css">
              .rules-section .row.row5 {
                margin-left: -5px;
                margin-right: -5px;
              }
              .rules-section .pl-2 {
                padding-left: 0.5rem !important;
              }
              .rules-section .pr-2 {
                padding-right: 0.5rem !important;
              }
              .rules-section .row.row5 > [class*="col-"],
              .rules-section .row.row5 > [class*="col"] {
                padding-left: 5px;
                padding-right: 5px;
              }
              .rules-section {
                text-align: left;
                margin-bottom: 10px;
              }
              .rules-section .table {
                color: #fff;
                border: 1px solid #444;
                background-color: #222;
                font-size: 12px;
              }
              .rules-section .table td,
              .rules-section .table th {
                border-bottom: 1px solid #444;
                border-right: 1px solid #444;
                vertical-align: middle;
                text-align: center;
              }
              .rules-section ul li,
              .rules-section p {
                margin-bottom: 5px;
              }
              .rules-section::-webkit-scrollbar {
                width: 8px;
              }
              .rules-section::-webkit-scrollbar-track {
                background: #666666;
              }

              .rules-section::-webkit-scrollbar-thumb {
                background-color: #333333;
              }
              .rules-section .rules-highlight {
                color: #fdcf13;
                font-size: 16px;
              }
              .rules-section .rules-sub-highlight {
                color: #fdcf13;
                font-size: 14px;
              }
              .rules-section .list-style,
              .rules-section .list-style li {
                list-style: disc;
              }
              .rules-section .rule-card {
                height: 20px;
                margin-left: 5px;
              }
              .rules-section .card-character {
                font-family: Card Characters;
              }
              .rules-section .red-card {
                color: red;
              }
              .rules-section .black-card {
                color: black;
              }
              .rules-section .cards-box {
                background: #fff;
                padding: 6px;
                display: inline-block;
                color: #000;
                min-width: 150px;
              }
              .rules-section .casino-tabs {
                background-color: #222 !important;
                border-radius: 0;
              }
              .rules-section .casino-tabs .nav-tabs .nav-link {
                color: #fff !important;
              }
              .rules-section .casino-tabs .nav-tabs .nav-link.active {
                color: #fdcf13 !important;
                border-bottom: 3px solid #fdcf13 !important;
              }
            </style>

            <div class="rules-section">
              <div class="table-responsive">
                <table class="table">
                  <thead>
                    <tr>
                      <th>Cards Deck</th>
                      <th>Value</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>6(SPADE) 6(HEART) 6(CLUB) 6(DIAMOND)</td>
                      <td>6 POINT</td>
                    </tr>
                    <tr>
                      <td>7(SPADE) 7(HEART) 7(CLUB) 7(DIAMOND)</td>
                      <td>7 POINT</td>
                    </tr>
                    <tr>
                      <td>8(SPADE) 8(HEART) 8(CLUB) 8(DIAMOND)</td>
                      <td>8 POINT</td>
                    </tr>
                    <tr>
                      <td>9(SPADE) 9(HEART) 9(CLUB) 9(DIAMOND)</td>
                      <td>9 POINT</td>
                    </tr>
                    <tr>
                      <td>10(SPADE) 10(HEART) 10(CLUB) 10(DIAMOND)</td>
                      <td>10 POINT</td>
                    </tr>
                    <tr>
                      <td>J(SPADE) J(HEART) J(CLUB) J(DIAMOND)</td>
                      <td>11 POINT</td>
                    </tr>
                    <tr>
                      <td>Q(SPADE) Q(HEART) Q(CLUB) Q(DIAMOND)</td>
                      <td>12 POINT</td>
                    </tr>
                    <tr>
                      <td>K(SPADE) K(HEART) K(CLUB) K(DIAMOND)</td>
                      <td>13 POINT</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <ul class="pl-4 pr-4 list-style">
                <li>
                  This is a value card game &amp; Winning result will count on
                  Highest cards total.
                </li>
                <li>
                  There are total 4 players, every player have default prefix
                  points. Default points will be consider as following table.
                </li>
              </ul>
              <h6 class="rules-highlight">Playing Game Rules:</h6>
              <div class="table-responsive">
                <table class="table">
                  <tbody>
                    <tr>
                      <td>
                        <div><b>PLAYER 8</b></div>
                        <div>8 Point</div>
                      </td>
                      <td>
                        <div><b>PLAYER 9</b></div>
                        <div>9 Point</div>
                      </td>
                      <td>
                        <div><b>PLAYER 10</b></div>
                        <div>10 Point</div>
                      </td>
                      <td>
                        <div><b>PLAYER 11</b></div>
                        <div>11 Point</div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <ul class="pl-4 pr-4 list-style">
                <li>
                  In game, every player has to count sum of default points and
                  their ownopened card's point.
                </li>
                <li>
                  If in first level, the sum is same with more than one player,
                  then thatwill be tie and winner tied players go for next
                  level.
                </li>
                <li>
                  This sum will go and go upto Single Player Highest Sum of
                  Point.
                </li>
                <li>
                  At last Highest Point Cards's Player declare as a Winner.
                </li>
              </ul>
            </div>
          </div>
        </div>
        <!-- card32B -->
        <div class="rules-body" *ngIf="gtype == 'card32b'">
          <div>
            <style type="text/css">
              .rules-section .row.row5 {
                margin-left: -5px;
                margin-right: -5px;
              }
              .rules-section .pl-2 {
                padding-left: 0.5rem !important;
              }
              .rules-section .pr-2 {
                padding-right: 0.5rem !important;
              }
              .rules-section .row.row5 > [class*="col-"],
              .rules-section .row.row5 > [class*="col"] {
                padding-left: 5px;
                padding-right: 5px;
              }
              .rules-section {
                text-align: left;
                margin-bottom: 10px;
              }
              .rules-section .table {
                color: #fff;
                border: 1px solid #444;
                background-color: #222;
                font-size: 12px;
              }
              .rules-section .table td,
              .rules-section .table th {
                border-bottom: 1px solid #444;
                border-right: 1px solid #444;
                vertical-align: middle;
                text-align: center;
              }
              .rules-section ul li,
              .rules-section p {
                margin-bottom: 5px;
              }
              .rules-section::-webkit-scrollbar {
                width: 8px;
              }
              .rules-section::-webkit-scrollbar-track {
                background: #666666;
              }

              .rules-section::-webkit-scrollbar-thumb {
                background-color: #333333;
              }
              .rules-section .rules-highlight {
                color: #fdcf13;
                font-size: 16px;
              }
              .rules-section .rules-sub-highlight {
                color: #fdcf13;
                font-size: 14px;
              }
              .rules-section .list-style,
              .rules-section .list-style li {
                list-style: disc;
              }
              .rules-section .rule-card {
                height: 20px;
                margin-left: 5px;
              }
              .rules-section .card-character {
                font-family: Card Characters;
              }
              .rules-section .red-card {
                color: red;
              }
              .rules-section .black-card {
                color: black;
              }
              .rules-section .cards-box {
                background: #fff;
                padding: 6px;
                display: inline-block;
                color: #000;
                min-width: 150px;
              }
              .rules-section .casino-tabs {
                background-color: #222 !important;
                border-radius: 0;
              }
              .rules-section .casino-tabs .nav-tabs .nav-link {
                color: #fff !important;
              }
              .rules-section .casino-tabs .nav-tabs .nav-link.active {
                color: #fdcf13 !important;
                border-bottom: 3px solid #fdcf13 !important;
              }
            </style>

            <div class="rules-section">
              <div class="table-responsive">
                <table class="table">
                  <thead>
                    <tr>
                      <th>Cards Deck</th>
                      <th>Value</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>6(SPADE) 6(HEART) 6(CLUB) 6(DIAMOND)</td>
                      <td>6 POINT</td>
                    </tr>
                    <tr>
                      <td>7(SPADE) 7(HEART) 7(CLUB) 7(DIAMOND)</td>
                      <td>7 POINT</td>
                    </tr>
                    <tr>
                      <td>8(SPADE) 8(HEART) 8(CLUB) 8(DIAMOND)</td>
                      <td>8 POINT</td>
                    </tr>
                    <tr>
                      <td>9(SPADE) 9(HEART) 9(CLUB) 9(DIAMOND)</td>
                      <td>9 POINT</td>
                    </tr>
                    <tr>
                      <td>10(SPADE) 10(HEART) 10(CLUB) 10(DIAMOND)</td>
                      <td>10 POINT</td>
                    </tr>
                    <tr>
                      <td>J(SPADE) J(HEART) J(CLUB) J(DIAMOND)</td>
                      <td>11 POINT</td>
                    </tr>
                    <tr>
                      <td>Q(SPADE) Q(HEART) Q(CLUB) Q(DIAMOND)</td>
                      <td>12 POINT</td>
                    </tr>
                    <tr>
                      <td>K(SPADE) K(HEART) K(CLUB) K(DIAMOND)</td>
                      <td>13 POINT</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <ul class="pl-4 pr-4 list-style">
                <li>
                  This is a value card game &amp; Winning result will count on
                  Highest cards total.
                </li>
                <li>
                  There are total 4 players, every player have default prefix
                  points. Default points will be consider as following table.
                </li>
              </ul>
              <h6 class="rules-highlight">Playing Game Rules:</h6>
              <div class="table-responsive">
                <table class="table">
                  <tbody>
                    <tr>
                      <td>
                        <div><b>PLAYER 8</b></div>
                        <div>8 Point</div>
                      </td>
                      <td>
                        <div><b>PLAYER 9</b></div>
                        <div>9 Point</div>
                      </td>
                      <td>
                        <div><b>PLAYER 10</b></div>
                        <div>10 Point</div>
                      </td>
                      <td>
                        <div><b>PLAYER 11</b></div>
                        <div>11 Point</div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <ul class="pl-4 pr-4 list-style">
                <li>
                  In game, every player has to count sum of default points and
                  their ownopened card's point.
                </li>
                <li>
                  If in first level, the sum is same with more than one player,
                  then thatwill be tie and winner tied players go for next
                  level.
                </li>
                <li>
                  This sum will go and go upto Single Player Highest Sum of
                  Point.
                </li>
                <li>
                  At last Highest Point Cards's Player declare as a Winner.
                </li>
              </ul>
            </div>
          </div>
        </div>
        <!--dtl20  -->
        <div class="rules-body" *ngIf="gtype == 'dtl20'">
          <div>
            <style type="text/css">
              .rules-section .row.row5 {
                margin-left: -5px;
                margin-right: -5px;
              }
              .rules-section .pl-2 {
                padding-left: 0.5rem !important;
              }
              .rules-section .pr-2 {
                padding-right: 0.5rem !important;
              }
              .rules-section .row.row5 > [class*="col-"],
              .rules-section .row.row5 > [class*="col"] {
                padding-left: 5px;
                padding-right: 5px;
              }
              .rules-section {
                text-align: left;
                margin-bottom: 10px;
              }
              .rules-section .table {
                color: #fff;
                border: 1px solid #444;
                background-color: #222;
                font-size: 12px;
              }
              .rules-section .table td,
              .rules-section .table th {
                border-bottom: 1px solid #444;
              }
              .rules-section ul li,
              .rules-section p {
                margin-bottom: 5px;
              }
              .rules-section::-webkit-scrollbar {
                width: 8px;
              }
              .rules-section::-webkit-scrollbar-track {
                background: #666666;
              }

              .rules-section::-webkit-scrollbar-thumb {
                background-color: #333333;
              }
              .rules-section .rules-highlight {
                color: #fdcf13;
                font-size: 16px;
              }
              .rules-section .rules-sub-highlight {
                color: #fdcf13;
                font-size: 14px;
              }
              .rules-section .list-style,
              .rules-section .list-style li {
                list-style: disc;
              }
              .rules-section .rule-card {
                height: 20px;
                margin-left: 5px;
              }
              .rules-section .card-character {
                font-family: Card Characters;
              }
              .rules-section .red-card {
                color: red;
              }
              .rules-section .black-card {
                color: black;
              }
              .rules-section .cards-box {
                background: #fff;
                padding: 6px;
                display: inline-block;
                color: #000;
                min-width: 150px;
              }
            </style>
            <div class="rules-section">
              <ul class="pl-4 pr-4 list-style">
                <li>
                  20-20 DTL(Dragon Tiger Lion) is a 52 playing cards game, In
                  DTL game 3 hands are dealt: for each 3 player. The player will
                  bets which will win.
                </li>
                <li>
                  The ranking of cards is, from lowest to highest: Ace, 2, 3, 4,
                  5, 6, 7,8, 9, 10, Jack, Queen and King when Ace is “1” and
                  King is “13”.
                </li>
                <li>
                  On same card with different suit, Winner will be declare based
                  on below winning suit sequence.
                  <p></p>
                  <div class="cards-box">
                    <span class="card-character black-card ml-1">1</span>
                    <span>1st</span>
                  </div>
                  <p></p>
                  <p></p>
                  <div class="cards-box">
                    <span class="card-character red-card ml-1">1</span>
                    <span>2nd</span>
                  </div>
                  <p></p>
                  <p></p>
                  <div class="cards-box">
                    <span class="card-character black-card ml-1">1]</span>
                    <span>3rd</span>
                  </div>
                  <p></p>
                  <p></p>
                  <div class="cards-box">
                    <span class="card-character red-card ml-1">1[</span>
                    <span>4th</span>
                  </div>
                  <p></p>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <!-- dtoneeday -->
        <div class="rules-body" *ngIf="gtype == 'dtoneday'">
          <div>
            <style type="text/css">
              .rules-section .row.row5 {
                margin-left: -5px;
                margin-right: -5px;
              }
              .rules-section .pl-2 {
                padding-left: 0.5rem !important;
              }
              .rules-section .pr-2 {
                padding-right: 0.5rem !important;
              }
              .rules-section .row.row5 > [class*="col-"],
              .rules-section .row.row5 > [class*="col"] {
                padding-left: 5px;
                padding-right: 5px;
              }
              .rules-section {
                text-align: left;
                margin-bottom: 10px;
              }
              .rules-section .table {
                color: #fff;
                border: 1px solid #444;
                background-color: #222;
                font-size: 12px;
              }
              .rules-section .table td,
              .rules-section .table th {
                border-bottom: 1px solid #444;
              }
              .rules-section ul li,
              .rules-section p {
                margin-bottom: 5px;
              }
              .rules-section::-webkit-scrollbar {
                width: 8px;
              }
              .rules-section::-webkit-scrollbar-track {
                background: #666666;
              }

              .rules-section::-webkit-scrollbar-thumb {
                background-color: #333333;
              }
              .rules-section .rules-highlight {
                color: #fdcf13;
                font-size: 16px;
              }
              .rules-section .rules-sub-highlight {
                color: #fdcf13;
                font-size: 14px;
              }
              .rules-section .list-style,
              .rules-section .list-style li {
                list-style: disc;
              }
              .rules-section .rule-card {
                height: 20px;
                margin-left: 5px;
              }
              .rules-section .card-character {
                font-family: Card Characters;
              }
              .rules-section .red-card {
                color: red;
              }
              .rules-section .black-card {
                color: black;
              }
              .rules-section .cards-box {
                background: #fff;
                padding: 6px;
                display: inline-block;
                color: #000;
                min-width: 150px;
              }
            </style>

            <div class="rules-section">
              <div>
                <img
                  style="height: 100%"
                  src="https://sitethemedata.com/v3/static/front/img/casino-rules/dt6.jpg"
                  class="img-fluid"
                />
              </div>
            </div>
          </div>
        </div>
        <!-- dt20 -->
        <div class="rules-body" *ngIf="gtype == 'dt20'">
          <div>
            <style type="text/css">
              .rules-section .row.row5 {
                margin-left: -5px;
                margin-right: -5px;
              }
              .rules-section .pl-2 {
                padding-left: 0.5rem !important;
              }
              .rules-section .pr-2 {
                padding-right: 0.5rem !important;
              }
              .rules-section .row.row5 > [class*="col-"],
              .rules-section .row.row5 > [class*="col"] {
                padding-left: 5px;
                padding-right: 5px;
              }
              .rules-section {
                text-align: left;
                margin-bottom: 10px;
              }
              .rules-section .table {
                color: #fff;
                border: 1px solid #444;
                background-color: #222;
                font-size: 12px;
              }
              .rules-section .table td,
              .rules-section .table th {
                border-bottom: 1px solid #444;
              }
              .rules-section ul li,
              .rules-section p {
                margin-bottom: 5px;
              }
              .rules-section::-webkit-scrollbar {
                width: 8px;
              }
              .rules-section::-webkit-scrollbar-track {
                background: #666666;
              }

              .rules-section::-webkit-scrollbar-thumb {
                background-color: #333333;
              }
              .rules-section .rules-highlight {
                color: #fdcf13;
                font-size: 16px;
              }
              .rules-section .rules-sub-highlight {
                color: #fdcf13;
                font-size: 14px;
              }
              .rules-section .list-style,
              .rules-section .list-style li {
                list-style: disc;
              }
              .rules-section .rule-card {
                height: 20px;
                margin-left: 5px;
              }
              .rules-section .card-character {
                font-family: Card Characters;
              }
              .rules-section .red-card {
                color: red;
              }
              .rules-section .black-card {
                color: black;
              }
              .rules-section .cards-box {
                background: #fff;
                padding: 6px;
                display: inline-block;
                color: #000;
                min-width: 150px;
              }
            </style>

            <div class="rules-section">
              <div>
                <img
                  style="height: 100%"
                  src="https://sitethemedata.com/v3/static/front/img/casino-rules/dt202.jpg"
                  class="img-fluid"
                />
              </div>
            </div>
          </div>
        </div>
        <!-- lucky 7 -->
        <div class="rules-body" *ngIf="gtype == 'lucky7a'">
          <div>
            <style type="text/css">
              .rules-section .row.row5 {
                margin-left: -5px;
                margin-right: -5px;
              }
              .rules-section .pl-2 {
                padding-left: 0.5rem !important;
              }
              .rules-section .pr-2 {
                padding-right: 0.5rem !important;
              }
              .rules-section .row.row5 > [class*="col-"],
              .rules-section .row.row5 > [class*="col"] {
                padding-left: 5px;
                padding-right: 5px;
              }
              .rules-section {
                text-align: left;
                margin-bottom: 10px;
              }
              .rules-section .table {
                color: #fff;
                border: 1px solid #444;
                background-color: #222;
                font-size: 12px;
              }
              .rules-section .table td,
              .rules-section .table th {
                border-bottom: 1px solid #444;
              }
              .rules-section ul li,
              .rules-section p {
                margin-bottom: 5px;
              }
              .rules-section::-webkit-scrollbar {
                width: 8px;
              }
              .rules-section::-webkit-scrollbar-track {
                background: #666666;
              }

              .rules-section::-webkit-scrollbar-thumb {
                background-color: #333333;
              }
              .rules-section .rules-highlight {
                color: #fdcf13;
                font-size: 16px;
              }
              .rules-section .rules-sub-highlight {
                color: #fdcf13;
                font-size: 14px;
              }
              .rules-section .list-style,
              .rules-section .list-style li {
                list-style: disc;
              }
              .rules-section .rule-card {
                height: 20px;
                margin-left: 5px;
              }
              .rules-section .card-character {
                font-family: Card Characters;
              }
              .rules-section .red-card {
                color: red;
              }
              .rules-section .black-card {
                color: black;
              }
              .rules-section .cards-box {
                background: #fff;
                padding: 6px;
                display: inline-block;
                color: #000;
                min-width: 150px;
              }
            </style>
            <div class="rules-section">
              <ul class="pl-4 pr-4 list-style">
                <li>
                  Lucky 7 is a 8 deck playing cards game, total 8 * 52 = 416
                  cards.
                </li>
                <li>If the card is from ACE to 6, LOW Wins.</li>
                <li>If the card is from 8 to KING, HIGH Wins.</li>
                <li>
                  If the card is 7, bets on high and low will lose 50% of the
                  bet amount.
                </li>
              </ul>
              <div>
                <b class="rules-sub-highlight">LOW:</b>1,2,3,4,5,6 |
                <b class="rules-sub-highlight">HIGH:</b>8,9,10,J,Q,K
              </div>
              <div>Payout:2.0</div>
              <br />
              <div><b class="rules-sub-highlight">EVEN:</b>2,4,6,8,10,Q</div>
              <div>Payout:2.10</div>
              <br />
              <div><b class="rules-sub-highlight">ODD:</b>1,3,5,7,9,J,K</div>
              <div>Payout:1.79</div>
              <br />
              <div>
                <b class="rules-sub-highlight">RED:</b>
              </div>
              <div>Payout:1.95</div>
              <br />
              <div>
                <b class="rules-sub-highlight">BLACK:</b>
              </div>
              <div>Payout:1.95</div>
              <br />
              <b class="rules-sub-highlight">CARDS:</b
              >1,2,3,4,5,6,7,8,9,10,J,Q,K
              <div>PAYOUT: 12.0</div>
            </div>
          </div>
        </div>
        <!-- lucky7b -->
        <div class="rules-body" *ngIf="gtype == 'lucky7b'">
          <div>
            <style type="text/css">
              .rules-section .row.row5 {
                margin-left: -5px;
                margin-right: -5px;
              }
              .rules-section .pl-2 {
                padding-left: 0.5rem !important;
              }
              .rules-section .pr-2 {
                padding-right: 0.5rem !important;
              }
              .rules-section .row.row5 > [class*="col-"],
              .rules-section .row.row5 > [class*="col"] {
                padding-left: 5px;
                padding-right: 5px;
              }
              .rules-section {
                text-align: left;
                margin-bottom: 10px;
              }
              .rules-section .table {
                color: #fff;
                border: 1px solid #444;
                background-color: #222;
                font-size: 12px;
              }
              .rules-section .table td,
              .rules-section .table th {
                border-bottom: 1px solid #444;
              }
              .rules-section ul li,
              .rules-section p {
                margin-bottom: 5px;
              }
              .rules-section::-webkit-scrollbar {
                width: 8px;
              }
              .rules-section::-webkit-scrollbar-track {
                background: #666666;
              }

              .rules-section::-webkit-scrollbar-thumb {
                background-color: #333333;
              }
              .rules-section .rules-highlight {
                color: #fdcf13;
                font-size: 16px;
              }
              .rules-section .rules-sub-highlight {
                color: #fdcf13;
                font-size: 14px;
              }
              .rules-section .list-style,
              .rules-section .list-style li {
                list-style: disc;
              }
              .rules-section .rule-card {
                height: 20px;
                margin-left: 5px;
              }
              .rules-section .card-character {
                font-family: Card Characters;
              }
              .rules-section .red-card {
                color: red;
              }
              .rules-section .black-card {
                color: black;
              }
              .rules-section .cards-box {
                background: #fff;
                padding: 6px;
                display: inline-block;
                color: #000;
                min-width: 150px;
              }
            </style>
            <div class="rules-section">
              <ul class="pl-4 pr-4 list-style">
                <li>
                  Lucky 7 is a 8 deck playing cards game, total 8 * 52 = 416
                  cards.
                </li>
                <li>If the card is from ACE to 6, LOW Wins.</li>
                <li>If the card is from 8 to KING, HIGH Wins.</li>
                <li>
                  If the card is 7, bets on high and low will lose 50% of the
                  bet amount.
                </li>
              </ul>
              <div>
                <b class="rules-sub-highlight">LOW:</b>1,2,3,4,5,6 |
                <b class="rules-sub-highlight">HIGH:</b>8,9,10,J,Q,K
              </div>
              <div>Payout:2.0</div>
              <br />
              <div><b class="rules-sub-highlight">EVEN:</b>2,4,6,8,10,Q</div>
              <div>Payout:2.10</div>
              <br />
              <div><b class="rules-sub-highlight">ODD:</b>1,3,5,7,9,J,K</div>
              <div>Payout:1.79</div>
              <br />
              <div>
                <b class="rules-sub-highlight">RED:</b>
              </div>
              <div>Payout:1.95</div>
              <br />
              <div>
                <b class="rules-sub-highlight">BLACK:</b>
              </div>
              <div>Payout:1.95</div>
              <br />
              <b class="rules-sub-highlight">CARDS:</b
              >1,2,3,4,5,6,7,8,9,10,J,Q,K
              <div>PAYOUT: 12.0</div>
            </div>
          </div>
        </div>
        <!-- poker 6 players -->
        <div class="rules-body" *ngIf="gtype == 'poker6'">
          <div>
            <style type="text/css">
              .rules-section .row.row5 {
                margin-left: -5px;
                margin-right: -5px;
              }
              .rules-section .pl-2 {
                padding-left: 0.5rem !important;
              }
              .rules-section .pr-2 {
                padding-right: 0.5rem !important;
              }
              .rules-section .row.row5 > [class*="col-"],
              .rules-section .row.row5 > [class*="col"] {
                padding-left: 5px;
                padding-right: 5px;
              }
              .rules-section {
                text-align: left;
                margin-bottom: 10px;
              }
              .rules-section .table {
                color: #fff;
                border: 1px solid #444;
                background-color: #222;
                font-size: 12px;
              }
              .rules-section .table td,
              .rules-section .table th {
                border-bottom: 1px solid #444;
              }
              .rules-section ul li,
              .rules-section p {
                margin-bottom: 5px;
              }
              .rules-section::-webkit-scrollbar {
                width: 8px;
              }
              .rules-section::-webkit-scrollbar-track {
                background: #666666;
              }

              .rules-section::-webkit-scrollbar-thumb {
                background-color: #333333;
              }
              .rules-section .rules-highlight {
                color: #fdcf13;
                font-size: 16px;
              }
              .rules-section .rules-sub-highlight {
                color: #fdcf13;
                font-size: 14px;
              }
              .rules-section .list-style,
              .rules-section .list-style li {
                list-style: disc;
              }
              .rules-section .rule-card {
                height: 20px;
                margin-left: 5px;
              }
              .rules-section .card-character {
                font-family: Card Characters;
              }
              .rules-section .red-card {
                color: red;
              }
              .rules-section .black-card {
                color: black;
              }
              .rules-section .cards-box {
                background: #fff;
                padding: 6px;
                display: inline-block;
                color: #000;
                min-width: 150px;
              }
              .rules-section img {
                max-width: 100%;
              }
            </style>

            <div class="rules-section">
              <div>
                <img
                  style="height: 100% !important"
                  src="https://sitethemedata.com/v3/static/front/img/casino-rules/poker6.jpg"
                  class="img-fluid"
                />
              </div>
            </div>
          </div>
        </div>
        <!-- poker 1 day -->
        <div
          class="rules-body"
          *ngIf="gtype == 'poker1day' || gtype == 'poker20'"
        >
          <div>
            <style type="text/css">
              .rules-section .row.row5 {
                margin-left: -5px;
                margin-right: -5px;
              }
              .rules-section .pl-2 {
                padding-left: 0.5rem !important;
              }
              .rules-section .pr-2 {
                padding-right: 0.5rem !important;
              }
              .rules-section .row.row5 > [class*="col-"],
              .rules-section .row.row5 > [class*="col"] {
                padding-left: 5px;
                padding-right: 5px;
              }
              .rules-section {
                text-align: left;
                margin-bottom: 10px;
              }
              .rules-section .table {
                color: #fff;
                border: 1px solid #444;
                background-color: #222;
                font-size: 12px;
              }
              .rules-section .table td,
              .rules-section .table th {
                border-bottom: 1px solid #444;
              }
              .rules-section ul li,
              .rules-section p {
                margin-bottom: 5px;
              }
              .rules-section::-webkit-scrollbar {
                width: 8px;
              }
              .rules-section::-webkit-scrollbar-track {
                background: #666666;
              }

              .rules-section::-webkit-scrollbar-thumb {
                background-color: #333333;
              }
              .rules-section .rules-highlight {
                color: #fdcf13;
                font-size: 16px;
              }
              .rules-section .rules-sub-highlight {
                color: #fdcf13;
                font-size: 14px;
              }
              .rules-section .list-style,
              .rules-section .list-style li {
                list-style: disc;
              }
              .rules-section .rule-card {
                height: 20px;
                margin-left: 5px;
              }
              .rules-section .card-character {
                font-family: Card Characters;
              }
              .rules-section .red-card {
                color: red;
              }
              .rules-section .black-card {
                color: black;
              }
              .rules-section .cards-box {
                background: #fff;
                padding: 6px;
                display: inline-block;
                color: #000;
                min-width: 150px;
              }
              .rules-section img {
                max-width: 100%;
              }
            </style>

            <div class="rules-section">
              <div>
                <img
                  style="height: 100% !important"
                  src="https://sitethemedata.com/v3/static/front/img/casino-rules/poker6.jpg"
                  class="img-fluid"
                />
              </div>
            </div>
          </div>
        </div>

        <!-- poker 20 -->

        <!-- teen 20 -->
        <div class="rules-body" *ngIf="gtype == 'teen'">
          <div>
            <style type="text/css">
              .rules-section .row.row5 {
                margin-left: -5px;
                margin-right: -5px;
              }
              .rules-section .pl-2 {
                padding-left: 0.5rem !important;
              }
              .rules-section .pr-2 {
                padding-right: 0.5rem !important;
              }
              .rules-section .row.row5 > [class*="col-"],
              .rules-section .row.row5 > [class*="col"] {
                padding-left: 5px;
                padding-right: 5px;
              }
              .rules-section {
                text-align: left;
                margin-bottom: 10px;
              }
              .rules-section .table {
                color: #fff;
                border: 1px solid #444;
                background-color: #222;
                font-size: 12px;
              }
              .rules-section .table td,
              .rules-section .table th {
                border-bottom: 1px solid #444;
              }
              .rules-section ul li,
              .rules-section p {
                margin-bottom: 5px;
              }
              .rules-section::-webkit-scrollbar {
                width: 8px;
              }
              .rules-section::-webkit-scrollbar-track {
                background: #666666;
              }

              .rules-section::-webkit-scrollbar-thumb {
                background-color: #333333;
              }
              .rules-section .rules-highlight {
                color: #fdcf13;
                font-size: 16px;
              }
              .rules-section .rules-sub-highlight {
                color: #fdcf13;
                font-size: 14px;
              }
              .rules-section .list-style,
              .rules-section .list-style li {
                list-style: disc;
              }
              .rules-section .rule-card {
                height: 20px;
                margin-left: 5px;
              }
              .rules-section .card-character {
                font-family: Card Characters;
              }
              .rules-section .red-card {
                color: red;
              }
              .rules-section .black-card {
                color: black;
              }
              .rules-section .cards-box {
                background: #fff;
                padding: 6px;
                display: inline-block;
                color: #000;
                min-width: 150px;
              }
              .rules-section img {
                max-width: 100%;
              }
            </style>

            <div class="rules-section">
              <ul class="pl-2 pr-2 list-style">
                <li>
                  The game is played with a regular 52 cards single deck,
                  between 2 players A and B.
                </li>
                <li>Each player will receive 3 cards.</li>
                <li><b>Rules of regular teenpatti winner</b></li>
              </ul>
              <div>
                <img
                  style="height: 100%"
                  src="https://sitethemedata.com/casino-new-rules-images/teen20b.jpg"
                />
              </div>
            </div>
          </div>
          <div>
            <div class="rules-section">
              <h6 class="rules-highlight">Rules of 3 baccarat</h6>
              <p>There are 3 criteria for winning the 3 Baccarat .</p>
              <h5 class="rules-sub-highlight">First criteria:</h5>
              <ul class="pl-2 pr-2 list-style">
                <li>Game having trio will win,</li>
                <li>If both game has trio then higher trio will win.</li>
                <li>
                  Ranking of trio from high to low.
                  <div class="pl-2 pr-2">1,1,1</div>
                  <div class="pl-2 pr-2">K,K,K</div>
                  <div class="pl-2 pr-2">Q,Q,Q</div>
                  <div class="pl-2 pr-2">J,J,J</div>
                  <div class="pl-2 pr-2">10,10,10</div>
                  <div class="pl-2 pr-2">9,9,9</div>
                  <div class="pl-2 pr-2">8,8,8</div>
                  <div class="pl-2 pr-2">7,7,7</div>
                  <div class="pl-2 pr-2">6,6,6</div>
                  <div class="pl-2 pr-2">5,5,5</div>
                  <div class="pl-2 pr-2">4,4,4</div>
                  <div class="pl-2 pr-2">3,3,3</div>
                  <div class="pl-2 pr-2">2,2,2</div>
                </li>
                <li>
                  If none of the game have got trio then second criteria will
                  apply.
                </li>
              </ul>
              <h5 class="rules-sub-highlight">Second criteria:</h5>
              <ul class="pl-2 pr-2 list-style">
                <li>Game having all the three face card will win.</li>
                <li>Here JACK, QUEEN AND KING are named face card.</li>
                <li>
                  if both the game have all three face cards then game having
                  highest face card will win.
                </li>
                <li>
                  Ranking of face card from High to low :
                  <div class="pl-2 pr-2">Spade King</div>
                  <div class="pl-2 pr-2">Heart King</div>
                  <div class="pl-2 pr-2">Club King</div>
                  <div class="pl-2 pr-2">Diamond King</div>
                </li>
                <li>Same order will apply for Queen (Q) and Jack (J) also .</li>
                <li>
                  If second criteria is also not applicable, then 3rd criteria
                  will apply .
                </li>
              </ul>
              <h5 class="rules-sub-highlight">3rd criteria:</h5>
              <ul class="pl-2 pr-2 list-style">
                <li>Game having higher baccarat value will win .</li>
                <li>
                  For deciding baccarat value we will add point value of all the
                  three cards
                </li>
                <li>
                  Point value of all the cards :
                  <div class="pl-2 pr-2">1 = 1</div>
                  <div class="pl-2 pr-2">2 = 2</div>
                  <div class="pl-2 pr-2">To</div>
                  <div class="pl-2 pr-2">9 = 9</div>
                  <div class="pl-2 pr-2">
                    10, J ,Q, K has zero (0) point value .
                  </div>
                </li>
              </ul>
              <p><b>Example 1st:</b></p>
              <ul class="pl-2 pr-2 list-style">
                <li>
                  Last digit of total will be considered as baccarat value
                  <div class="pl-2 pr-2">2,5,8 =</div>
                  <div class="pl-2 pr-2">
                    2+5+8 =15 here last digit of total is 5 , So baccarat value
                    is 5.
                  </div>
                </li>
              </ul>
              <p><b>Example 2nd :</b></p>
              <ul class="pl-2 pr-2 list-style">
                <li>1,3,K</li>
                <li>
                  1+3+0 = 4 here total is in single digit so we will take this
                  single digit 4 as baccarat value
                </li>
              </ul>
              <p>
                <b
                  >If baccarat value of both the game is equal then Following
                  condition will apply :</b
                >
              </p>
              <p><b>Condition 1 :</b></p>
              <ul class="pl-2 pr-2 list-style">
                <li>Game having more face card will win.</li>
                <li>
                  Example : Game A has 3,4,k and B has 7,J,Q then game B will
                  win as it has more face card then game A .
                </li>
              </ul>
              <p><b>Condition 2 :</b></p>
              <ul class="pl-2 pr-2 list-style">
                <li>
                  If Number of face card of both the game are equal then higher
                  value face card game will win.
                </li>
                <li>
                  Example : Game A has 4,5,K (K Spade ) and Game B has 9,10,K (
                  K Heart ) here baccarat value of both the game is equal (9 )
                  and both the game have same number of face card so game A will
                  win because It has got higher value face card then Game B .
                </li>
              </ul>
              <p><b>Condition 3 :</b></p>
              <ul class="pl-2 pr-2 list-style">
                <li>
                  If baccarat value of both the game is equal and none of game
                  has got face card then in this case Game having highest value
                  point card will win .
                </li>
                <li>
                  Value of Point Cards :
                  <div class="pl-2 pr-2">Ace = 1</div>
                  <div class="pl-2 pr-2">2 = 2</div>
                  <div class="pl-2 pr-2">3 = 3</div>
                  <div class="pl-2 pr-2">4 = 4</div>
                  <div class="pl-2 pr-2">5 = 5</div>
                  <div class="pl-2 pr-2">6 = 6</div>
                  <div class="pl-2 pr-2">7 = 7</div>
                  <div class="pl-2 pr-2">8 = 8</div>
                  <div class="pl-2 pr-2">9 = 9</div>
                  <div class="pl-2 pr-2">10 = 0 (Zero )</div>
                </li>
                <li>Example : GameA: 1,6,10 And GameB: 7,10,10</li>
                <li>
                  here both the game have same baccarat value . But game B will
                  win as it has higher value point card i.e. 7 .
                </li>
              </ul>
              <p><b>Condition 4 :</b></p>
              <ul class="pl-2 pr-2 list-style">
                <li>
                  If baccarat value of both game is equal and none of game has
                  got face card and high point card of both the game is of equal
                  point value , then suits of both high card will be compared
                </li>
                <li>
                  Example :
                  <div class="pl-2 pr-2">
                    Game A : 1(Heart) ,2(Heart) ,5(Heart)
                  </div>
                  <div class="pl-2 pr-2">
                    Game B : 10 (Heart) , 3 (Diamond ) , 5 (Spade )
                  </div>
                </li>
                <li>
                  Here Baccarat value of both the game (8) is equal . and none
                  of game has got face card and point value of both game's high
                  card is equal so by comparing suits of both the high card ( A
                  5 of Heart , B 5 of spade ) game B is declared 3 Baccarat
                  winner .
                </li>
                <li>
                  Ranking of suits from High to low :
                  <div class="pl-2 pr-2">Spade</div>
                  <div class="pl-2 pr-2">Heart</div>
                  <div class="pl-2 pr-2">Club</div>
                  <div class="pl-2 pr-2">Diamond</div>
                </li>
              </ul>
            </div>
          </div>
          <div>
            <div class="rules-section">
              <h6 class="rules-highlight">Rules of Total :</h6>
              <ul class="pl-2 pr-2 list-style">
                <li>
                  It is a comparison of total of all three cards of both the
                  games.
                </li>
                <li>
                  Point value of all the cards for the bet of total
                  <div class="pl-2 pr-2">Ace = 1</div>
                  <div class="pl-2 pr-2">2 = 2</div>
                  <div class="pl-2 pr-2">3 = 3</div>
                  <div class="pl-2 pr-2">4 = 4</div>
                  <div class="pl-2 pr-2">5 = 5</div>
                  <div class="pl-2 pr-2">6 = 6</div>
                  <div class="pl-2 pr-2">7 = 7</div>
                  <div class="pl-2 pr-2">8 = 8</div>
                  <div class="pl-2 pr-2">9 = 9</div>
                  <div class="pl-2 pr-2">10 = 10</div>
                  <div class="pl-2 pr-2">Jack = 11</div>
                  <div class="pl-2 pr-2">Queen = 12</div>
                  <div class="pl-2 pr-2">King = 13</div>
                </li>
                <li>suits doesn't matter</li>
                <li>If total of both the game is equal , it is a Tie .</li>
                <li>
                  If total of both the game is equal then half of your bet
                  amount will returned.
                </li>
              </ul>
            </div>
          </div>
          <div>
            <div class="rules-section">
              <h6 class="rules-highlight">Rules of Pair Plus :</h6>
              <ul class="pl-2 pr-2 list-style">
                <li>This bet provides multiple option to win a price .</li>
                <li>Option 1 : Pair</li>
                <li>
                  If you got pair you will get equal value return of your
                  betting amount .
                </li>
                <li>Option 2 : Flush</li>
                <li>
                  If you have all three cards of same suits you will get 4 times
                  return of your betting amount .
                </li>
                <li>Option 3 : Straight</li>
                <li>
                  If you have straight ( three cards in sequence eg : 4,5,6 eg:
                  J,Q,K ) (but king ,Ace ,2 is not a straight ) you will get six
                  times return of your betting amount .
                </li>
                <li>Option 4 : Trio</li>
                <li>
                  If you have got all the cards of same rank ( eg: 4,4,4 J,J,J )
                  you will get 30 times return of your betting amount .
                </li>
                <li>Option 5 : Straight Flush</li>
                <li>
                  If you have straight of all three cards of same suits ( Three
                  cards in sequence eg: 4,5,6 ) ( but King ,Ace ,2 is not
                  straight ) you will get 40 times return of your betting amount
                  .
                </li>
                <li>
                  Note : If you have trio then you will receive price of trio
                  only , In this case you will not receive price of pair .
                </li>
                <li>
                  If you have straight flush you will receive price of straight
                  flush only , In this case you will not receive price of
                  straigh and flush .
                </li>
                <li>
                  It means you will receive only one price whichever is higher .
                </li>
              </ul>
            </div>
          </div>
          <div>
            <div class="rules-section">
              <h6 class="rules-highlight">Rules of Color :</h6>
              <ul class="pl-2 pr-2 list-style">
                <li>
                  This is a bet for having more cards of red or Black (Heart and
                  Diamond are named RED , Spade and Club are named BLACK ).
                </li>
                <li>
                  <b>NOTE :</b> For side bets you can place bets on either or
                  both the players .
                </li>
                <li>
                  <b>NOTE :</b> In case of a tie between the player A and Player
                  B bets placed on player A and Player B (Main Bets ) will be
                  returned ( Pushed ).
                </li>
              </ul>
            </div>
          </div>
        </div>
        <!-- teen 1 day -->
        <div class="rules-body" *ngIf="gtype == 'teen1day'">
          <div>
            <style type="text/css">
              .rules-section .row.row5 {
                margin-left: -5px;
                margin-right: -5px;
              }

              .rules-section .pl-2 {
                padding-left: 0.5rem !important;
              }

              .rules-section .pr-2 {
                padding-right: 0.5rem !important;
              }

              .rules-section .row.row5 > [class*="col-"],
              .rules-section .row.row5 > [class*="col"] {
                padding-left: 5px;
                padding-right: 5px;
              }

              .rules-section {
                text-align: left;
                margin-bottom: 10px;
              }

              .rules-section .table {
                color: #fff;
                border: 1px solid #444;
                background-color: #222;
                font-size: 12px;
              }

              .rules-section .table td,
              .rules-section .table th {
                border-bottom: 1px solid #444;
              }

              .rules-section ul li,
              .rules-section p {
                margin-bottom: 5px;
              }

              .rules-section::-webkit-scrollbar {
                width: 8px;
              }

              .rules-section::-webkit-scrollbar-track {
                background: #666666;
              }

              .rules-section::-webkit-scrollbar-thumb {
                background-color: #333333;
              }

              .rules-section .rules-highlight {
                color: #fdcf13;
                font-size: 16px;
              }

              .rules-section .rules-sub-highlight {
                color: #fdcf13;
                font-size: 14px;
              }

              .rules-section .list-style,
              .rules-section .list-style li {
                list-style: disc;
              }

              .rules-section .rule-card {
                height: 20px;
                margin-left: 5px;
              }

              .rules-section .card-character {
                font-family: Card Characters;
              }

              .rules-section .red-card {
                color: red;
              }

              .rules-section .black-card {
                color: black;
              }

              .rules-section .cards-box {
                background: #fff;
                padding: 6px;
                display: inline-block;
                color: #000;
                min-width: 150px;
              }
              .rules-section img {
                max-width: 100%;
              }
            </style>

            <div class="rules-section">
              <ul class="pl-4 pr-4 list-style">
                <li>Teenpatti is an indian origin three cards game.</li>
                <li>
                  This game is played with a regular 52 cards deck between
                  Player A and Player B .
                </li>
                <li>
                  The objective of the game is to make the best three cards hand
                  as per the hand rankings and win.
                </li>
                <li>
                  You have a betting option of Back and Lay for the main bet.
                </li>
                <li>Rankings of the card hands from highest to lowest :</li>
                <li>1. Straight Flush (pure Sequence )</li>
                <li>2. Trail (Three of a Kind )</li>
                <li>3. Straight (Sequence)</li>
                <li>4. Flush (Color )</li>
                <li>5. Pair (Two of a kind )</li>
                <li>6. High Card</li>
              </ul>
              <div>
                <img
                  style="height: 100%"
                  src="https://sitethemedata.com/v3/static/front/img/casino-rules/teen6.jpg"
                  class="img-fluid"
                />
              </div>
            </div>
          </div>
          <div>
            <div class="rules-section">
              <div>
                <h6 class="rules-highlight">Side bets :</h6>
              </div>
              <ul class="pl-4 pr-4 list-style">
                <li>
                  <b>CONSECUTIVE CARDS:</b> It is a bet of having two or more
                  consecutive cards in the game.
                </li>
                <li>eg: 2,3,5 10,3,9 Q,5,K 6,7,8 A,K,7</li>
                <li>
                  For both the players Back and Lay odds are available, you can
                  bet on either or both the players.
                </li>
                <li>
                  <b>Odd - Even :</b> Here you can bet on every card whether it
                  will be an odd card or an even card.
                </li>
                <li><b>ODD CARDS :</b> A,3,5,7,9,J,K</li>
                <li><b>EVEN CARDS:</b> 2,4,6,8,10,Q</li>
                <li>
                  <b>NOTE:</b> In case of a Tie between the player A and player
                  B bets placed on player A and player B (Main bets ) will be
                  returned. (Pushed)
                </li>
              </ul>
            </div>
          </div>
        </div>
        <!-- teen open test -->
        <div class="rules-body" *ngIf="gtype == 'teenopentest'">
          <div>
            <style type="text/css">
              .rules-section .row.row5 {
                margin-left: -5px;
                margin-right: -5px;
              }
              .rules-section .pl-2 {
                padding-left: 0.5rem !important;
              }
              .rules-section .pr-2 {
                padding-right: 0.5rem !important;
              }
              .rules-section .row.row5 > [class*="col-"],
              .rules-section .row.row5 > [class*="col"] {
                padding-left: 5px;
                padding-right: 5px;
              }
              .rules-section {
                text-align: left;
                margin-bottom: 10px;
              }
              .rules-section .table {
                color: #fff;
                border: 1px solid #444;
                background-color: #222;
                font-size: 12px;
              }
              .rules-section .table td,
              .rules-section .table th {
                border-bottom: 1px solid #444;
              }
              .rules-section ul li,
              .rules-section p {
                margin-bottom: 5px;
              }
              .rules-section::-webkit-scrollbar {
                width: 8px;
              }
              .rules-section::-webkit-scrollbar-track {
                background: #666666;
              }

              .rules-section::-webkit-scrollbar-thumb {
                background-color: #333333;
              }
              .rules-section .rules-highlight {
                color: #fdcf13;
                font-size: 16px;
              }
              .rules-section .rules-sub-highlight {
                color: #fdcf13;
                font-size: 14px;
              }
              .rules-section .list-style,
              .rules-section .list-style li {
                list-style: disc;
              }
              .rules-section .rule-card {
                height: 20px;
                margin-left: 5px;
              }
              .rules-section .card-character {
                font-family: Card Characters;
              }
              .rules-section .red-card {
                color: red;
              }
              .rules-section .black-card {
                color: black;
              }
              .rules-section .cards-box {
                background: #fff;
                padding: 6px;
                display: inline-block;
                color: #000;
                min-width: 150px;
              }
              .rules-section img {
                max-width: 100%;
              }
            </style>

            <div class="rules-section">
              <div>
                <img
                  style="height: 100% !important"
                  src="https://sitethemedata.com/v3/static/front/img/casino-rules/teen6.jpg"
                  class="img-fluid"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- <div class="container-fluid p-0 m-0">
  <div class="card border-0 p-0 m-0">
    <div class="card-header-grey">
      <div class="h4 ml-2">Rules</div>
    </div>
    <div class="card-body p-2" style="background: white !important; border-radius: 5px;">
      <div *ngFor="let section of sections">
        <button
          type="button"
          class="btn btn-block btn-primary text-left w-100 text-start"
          (click)="toggleCollapse(section.name)"
          [attr.aria-expanded]="!section.state"
          [attr.aria-controls]="section.name"
        >
          {{ section.fullname }}
        </button>
        <div [attr.id]="section.name" #collapseSection="ngbCollapse" class="p-2 card-details" [(ngbCollapse)]="section.state">
          <p [class.imp]="data.isImportant" *ngFor="let data of section.data">{{ data.text }}</p>
        </div>
      </div>
    </div>
  </div>
</div> -->
